import { IPagination } from 'app/types/common';

export interface IOrgCustomersState {
  readonly orgCustomersById?: any;
  readonly orgCustomerIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectOrgCustomerLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddOrgCustomer?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationOrgCustomerIds?: string[];
  readonly currentOrgCustomerId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IOrgCustomersSelector extends IOrgCustomersState {
  readonly currentOrgCustomer?: any;
  readonly currentFormOrgCustomer?: any;
  readonly getOrgCustomersFilteredByTagInSelectFormat?: any;
  readonly orgCustomersByIdInSelectFormat?: any;
}

export enum OrgCustomersActionTypes {
  GET_ALL_ORG_CUSTOMERS_REQUESTED = 'redux-app/org-customers/GET_ALL_ORG_CUSTOMERS_REQUESTED',
  GET_ALL_ORG_CUSTOMERS_PENDING = 'redux-app/org-customers/GET_ALL_ORG_CUSTOMERS_PENDING',
  GET_ALL_ORG_CUSTOMERS_SUCCESS = 'redux-app/org-customers/GET_ALL_ORG_CUSTOMERS_SUCCESS',
  GET_ALL_ORG_CUSTOMERS_FAIL = 'redux-app/org-customers/GET_ALL_ORG_CUSTOMERS_FAIL',
  GET_ORG_CUSTOMER_REQUESTED = 'redux-app/org-customers/GET_ORG_CUSTOMER_REQUESTED',
  GET_ORG_CUSTOMER_PENDING = 'redux-app/org-customers/GET_ORG_CUSTOMER_PENDING',
  GET_ORG_CUSTOMER_SUCCESS = 'redux-app/org-customers/GET_ORG_CUSTOMER_SUCCESS',
  GET_ORG_CUSTOMER_FAIL = 'redux-app/org-customers/GET_ORG_CUSTOMER_FAIL',
  SELECT_ORG_CUSTOMER_REQUESTED = 'redux-app/org-customers/SELECT_ORG_CUSTOMER_REQUESTED',
}

export interface IOrgCustomer {
  id: string;
  organisationName: string;
  createdOn: string;
  updatedOn: string;
  fullName: string;
  email: string;
  mobile: string;
  customerType: string;
  uniqueKey: string;
  customerStatus: string;
  groupIds: string;
  competitionIds: string;
  groups: { name: string; id: string }[];
  competitions: { name: string; id: string }[];
  teamName: string;
  competitionName: string;
  seasonName: string;
  sectionName: string;
  numberOfGroups: number;
  numberOfCompetitions: number;
  numberOfMatches: number;
  unpaidNumberOfPayments: number;
  unpaidTotalPaymentsAmountInDollars: number;
  unpaidTotalPaymentsAmountInCents: number;
  paidNumberOfPayments: number;
  paidTotalPaymentsAmountInDollars: number;
  paidTotalPaymentsAmountInCents: number;
  overdueNumberOfPayments: number;
  overdueTotalPaymentsAmountInDollars: number;
  overdueTotalPaymentsAmountInCents: number;
  financialStatus: string;
  financialStatusHumanised: string;
  financialStatusColour: string;
}

export default null;
